import * as React from "react";
import styled from "styled-components";
import {CardHeader} from "./card-header";
import {CardBody} from "./card-body";

export const CardWrapper: React.FC<Props> = ({children, title, subtitle, color = 'black', style}) => (
    <StyledContainer style={style} color={color}>
        {title &&
            <CardHeader title={title} subtitle={subtitle} color={color}/>
        }
        <CardBody>{children}</CardBody>
    </StyledContainer>
);

const StyledContainer = styled(({color, ...rest}) => <div {...rest} />)<{ color: 'black' | 'white' }>`
  background-color: ${props => ((props.color) === 'black') ? '#fff' : 'rgba(255,255,255,0.1)'};
  border-radius: 3px;
  width: 100%;
`;

interface Props {
    title: string;
    color?: 'white' | 'black';
    subtitle?: string;
    style?: any;
}
